import React from 'react'

function Facebook(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0.8 0.58 33.82 33.83"
            height={props.height}
            width={props.width}
        >
            <path
                fill={props.colorOne}
                d="M17.7.58a16.91 16.91 0 110 33.83 16.91 16.91 0 010-33.83zm0 1.17a15.75 15.75 0 10.02 31.5 15.75 15.75 0 00-.01-31.5zm1.93 7.58l2.7.01v2.8h-1.96c-.32 0-.77.15-.77.79v1.7h2.78l-.32 2.88h-2.47v8.16h-3.64V17.5H14.2v-2.89h1.74v-1.86c0-1.34.68-3.43 3.68-3.43z"
            />
        </svg>
    )
}

export default Facebook
